/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Integration_Credentials_Updated_DescInputs */



/**
* | output |
* | --- |
* | "New credentials were stored for the {integration} integration, so its requests now run against a different account." |
*
* @param {Audit_Details_Integration_Credentials_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_credentials_updated_desc = /** @type {((inputs: Audit_Details_Integration_Credentials_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Credentials_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Für die Integration ${i?.integration} wurden neue Zugangsdaten gespeichert. Ihre Anfragen laufen jetzt über ein anderes Konto.`)
	return /** @type {LocalizedString} */ (`New credentials were stored for the ${i?.integration} integration, so its requests now run against a different account.`)
});